import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import { Form } from 'react-bootstrap'
import TreeView from 'react-treeview'
import ExtraGroup from './ExtraGroup.js'
import store from '../stores/store.js'

@inject("store")
@observer
export default class ExtraCategory extends Component {
  static propTypes = {
    extraCategory: PropTypes.object.isRequired,
    onClickExtra: PropTypes.func,
    showCheckboxes: PropTypes.bool
  }

  handleTreeClick = (id) => {
    const { store } = this.props
    store.toggleExtraCategoryCollapsed(id)
  }

  handleSelection = (id) => {
    const { store } = this.props
    store.toggleExtraCategorySelection(id)
  }

  renderExtraCategory() {
    const { extraCategory, onClickExtra } = this.props

    if(onClickExtra) {
      return (
        <span
          onClick={() => onClickExtra({extraCategory})}
          style={{...styles.extra, ...styles.clickableExtraCategory}}
        >
          { extraCategory.name }
        </span>
      )
    }
    else {
      return <span style={styles.extra}>{ extraCategory.name }</span>
    }
  }

  renderExtraCategoryCheckbox() {
    const { extraCategory, showCheckboxes } = this.props

    if(showCheckboxes) {
      return (
        <Form.Check
          type="checkbox"
          style={styles.checkbox}
          id={`extraCategory-${extraCategory.id}`}
          >
          <Form.Check.Input
            onChange={() => this.handleSelection(extraCategory.id)}
            checked={extraCategory.selected}
          />
          <Form.Check.Label>
            { this.renderExtraCategory() }
          </Form.Check.Label>
        </Form.Check>
      )
    }
    else {
      return this.renderExtraCategory()
    }
  }

  render() {
    const { extraCategory, showCheckboxes, onClickExtra } = this.props

    return (
      <TreeView
        onClick={() => this.handleTreeClick(extraCategory.id)}
        collapsed={extraCategory.collapsed}
        nodeLabel={this.renderExtraCategoryCheckbox()}
        >
        <div style={styles.offset}>
          {extraCategory.extraGroups.map(extraGroup =>
            <ExtraGroup
              key={extraGroup.id}
              extraGroup={extraGroup}
              onClickExtra={onClickExtra}
              showCheckboxes={showCheckboxes}
            />
          )}
        </div>
      </TreeView>
    )
  }
}

const styles = {
  checkbox: {
    display: "inline-block",
    marginTop: 0,
    marginBottom: 5
  },
  offset: {
    marginLeft: 10
  },
  clickableExtraCategory: {
    cursor: 'pointer',
    textDecoration: 'underline'
  },
  extra: {},
}